<template>
    <div class="filter_container">
        <h5 style="padding:10px 0px;">退票數詳細數據</h5>
        <div class="filter">
            <date-picker 
                :lang="lang"
                style="margin-right:5px;"
                v-model="start_at"
                placeholder="開始日期"
                format="YYYY-MM-DD"
            >
            </date-picker>
            <date-picker 
                :lang="lang"
                style="margin-right:5px;"
                placeholder="結束日期"
                v-model="end_at"
                format="YYYY-MM-DD"
            >
            </date-picker>

            <b-button
                v-on:click="getData(start_at, end_at)"
            >
                取得資料
            </b-button>

        </div>

        <div style="width: 100%;margin-top:1em;">
            <b-card no-body>
                <b-tabs card>

                    <b-tab title="創聯生醫國際股份有限公司" v-on:click="selected_merchant = ''; selected_store = ''" active>
                        <b-card-text>

                            <div style="display:flex; flex-direction:row;align-items: center;">

                                <!-- 圖表 -->
                                <div style="width:100%;min-width:50%;">
                                    <div style="height:300px;" class="chart-container">
                                        <LineChartGenerator
                                            :chart-options="chartOptions"
                                            :chart-data="merhcant_chart_data"
                                        />
                                    </div>
                                </div>
                                <!-- 統計數據 -->
                                <div style="width:20%" >
                                    <b-list-group>
                                        <b-list-group-item>
                                            <span class="float-left">Buty99：</span>
                                            <span class="float-right mr-2">302</span>
                                        </b-list-group-item>
                                        <b-list-group-item>
                                            <span class="float-left">蝦皮：</span>
                                            <span class="float-right mr-2">503</span>
                                        </b-list-group-item>
                                        <b-list-group-item>
                                            <span class="float-left">3T：</span>
                                            <span class="float-right mr-2">202</span>
                                        </b-list-group-item>
                                        <b-list-group-item>
                                            <span class="float-left">Line酷券：</span>
                                            <span class="float-right mr-2">101</span>
                                        </b-list-group-item>
                                    </b-list-group>
                                </div>


                            </div>
                            <div>

                                <!-- 報表 -->
                                <vue-good-table
                                    :columns="merchant_column"
                                    :rows="merchant_datas"
                                >
                                    <template slot="table-row" slot-scope="props">
                                        <span v-if="props.column.field == 'merchant_name'">
                                            <span style="color: #68acef; cursor:pointer;" v-on:click="selected_merchant = props.row">
                                                {{props.row.merchant_name}}
                                            </span> 
                                        </span>
                                    </template>
                                </vue-good-table>
                            </div>
                        </b-card-text>
                    </b-tab>
                </b-tabs>
            </b-card>
        </div>


        <loading
        :show="loading_config.show"
        :label="loading_config.label">
        </loading>
    </div>
</template>    
<script>

    import { 
        apiGetDirectusData 
    } from '@/api/Util.js'

    // 當然是要用別人做好的輪子！
    
    // 載入中視窗
    import loading from 'vue-full-loading'

    // 日期選擇器
    import 'vue2-datepicker/locale/zh-cn';
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';

    // 表格套件
    import 'vue-good-table/dist/vue-good-table.css'
    import { VueGoodTable } from 'vue-good-table';

    // 圖表套件
    import { Line as LineChartGenerator } from 'vue-chartjs/legacy'
    import {
        Chart as ChartJS,
        Title,
        Tooltip,
        Legend,
        LineElement,
        LinearScale,
        CategoryScale,
        PointElement
    } from 'chart.js'

    ChartJS.register(
        Title,
        Tooltip,
        Legend,
        LineElement,
        LinearScale,
        CategoryScale,
        PointElement
    )

    export default {
        components: { DatePicker, VueGoodTable, loading, LineChartGenerator, },
        name: 'DemoChart',
        data: function() {
            return {
                start_at: new Date(new Date().setDate(new Date().getDate() - 7)),
                end_at: new Date(),
                selected_merchant: '',
                selected_store: '',
                reservation_datas: [],
                merchant_datas: [
	                {
		                "product_id": "NI20220209000003",
		                "product_name": "《全台》160分鐘,全身寵愛極緻舒壓手雕按摩課程",
		                "buty99": 40,
		                "shopee": 30,
		                "3t": 23,
		                "line": 10
	                },
	                {
		                "product_id": "NI20220207000010",
		                "product_name": "《全台》160分鐘,全身寵愛極緻舒壓手雕按摩課程",
		                "buty99": 42,
		                "shopee": 10,
		                "3t": 5,
		                "line": 2
	                },
	                {
		                "product_id": "NI20220106000007",
		                "product_name": "《新北》130分鐘!熟男專屬**全身多特瑞香氛精油手技按摩樂活SPA",
		                "buty99": 12,
		                "shopee": 20,
		                "3t": 33,
		                "line": 21
	                }
                ],
                merchant_chart_data: {},
                store_datas: [],
                reservation_data_mapper: {},
                item_datas: [],
                lang: {
                    placeholder: {
                        date: '選擇日期'
                    }
                },
                merchant_column: [
                    {
                        label: '課程名稱',
                        field: 'product_name'
                    },
                    {
                        label: 'Buty99',
                        field: 'buty99'
                    },
                    {
                        label: '蝦皮',
                        field: 'shopee'
                    },
                    {
                        label: '3T',
                        field: '3t'
                    },
                    {
                        label: 'Line酷券',
                        field: 'line'
                    },
                ],
                store_column: [
                    {
                        label: '分店名稱',
                        field: 'store_name'
                    },
                    {
                        label: '完成預約數',
                        field: 'success'
                    },
                    {
                        label: '未完成預約數',
                        field: 'fail'
                    },
                    {
                        label: '總預約數',
                        field: 'total'
                    },
                ],
                item_column: [
                    {
                        label: '課程名稱',
                        field: 'item_name'
                    },
                    {
                        label: '完成預約數',
                        field: 'success'
                    },
                    {
                        label: '未完成預約數',
                        field: 'fail'
                    },
                    {
                        label: '總預約數',
                        field: 'total'
                    },
                ],
                loading_config: {
                    show: false,
                    label: '載入資料中'
                },

                merhcant_chart_data: {
                    labels: [
                        "2022-12-01",
                        "2022-12-02",
                        "2022-12-03",
                        "2022-12-04",
                        "2022-12-05",
                    ],
                    datasets:[
                        {
                            label: 'Buty99',
                            data: [10,42, 1, 9, 11],
                            backgroundColor: '#f87979',
                            borderColor: '#f87979',
                        },
                        {
                            label: '蝦皮',
                            data: [20, 19, 5, 7, 63],
                            backgroundColor: '#7292d3',
                            borderColor: '#7292d3',
                        },
                        {
                            label: '3T',
                            data: [50, 79, 3, 22, 88],
                            backgroundColor: '#45ba36',
                            borderColor: '#45ba36',
                        },
                        {
                            label: 'Line酷券',
                            data: [90, 12, 19, 13, 55],
                            backgroundColor: '#d89531',
                            borderColor: '#d89531',
                        }
                    ]
                },
                chartOptions: {
                    responsive: true,
                    maintainAspectRatio: false
                }

            }
        },
        methods: {
            getReservationData: async function(start_at, end_at) {
                let data = []
                let params = {}
                start_at = start_at.toLocaleDateString().replaceAll('/', '-')
                end_at = end_at.toLocaleDateString().replaceAll('/', '-')

                this.loading_config.show = true
                params = { 
                    query: 
                        `query {
                        reservation(
                                limit: -1
                                filter: {
                                    date_created: { 
                                        _between: [ "${start_at}", "${end_at}"]
                                    }
                                }
                                sort: [ "date_created" ]
                            ) {
                                id

                                order {
                                    order_id
                                }

                                # 進線預約時間
                                date_created

                                # 敲定預約時間
                                commit_confirm_time

                                rv_commit_time

                                # 店家id
                                buty_store {
                                        merchant{
                                            id
                                            name
                                        }
                                        store_id
                                        store_name
                                        merchant_name
                                        longitude
                                }
                                product {
                                    product_cname
                                    ns_id
                                }
                            }
                        }`,
                    variables: {}
                }
                data = await apiGetDirectusData(params).then(function(resp){
                    console.log(resp)
                    let data = resp.data.data.data.data.reservation
                    return data
                }).catch(function(error){
                    console.log(error)
                })
                this.loading_config.show = false

                console.log('all_reservation_data', data)

                data = data.filter(function(item) {
                    return item.buty_store !== null
                })

                console.log('filter_buty_store_not_null', data)

                return data
            },
            getData: async function(start_at, end_at) {
                let that = this

                this.reservation_datas = await this.getReservationData(start_at, end_at)

                // 以供應商為單位處理資料
                let result = this.handleData(this.reservation_datas)
                this.merchant_datas = result.merchant_datas
                this.reservation_data_mapper = result.reservation_data_mapper
                this.merchant_chart_data = result.merchant_chart_data

                // 建立日期的labels
                let day_labels = Object.keys(this.merchant_chart_data)

                let success_datas = day_labels.map(function(day) {
                    return that.merchant_chart_data[day]['success']
                })

                let fail_datas = day_labels.map(function(day) {
                    return that.merchant_chart_data[day]['fail']
                })

                this.merhcant_chart_data.labels = day_labels
                this.merhcant_chart_data.datasets = [
                    {
                        label: '未完成預約',
                        backgroundColor: '#fe6483',
                        borderColor: '#fe6483',
                        data: fail_datas,
                    },
                    {
                        label: '已完成預約',
                        backgroundColor: '#4bc0c0',
                        borderColor: '#4bc0c0',
                        data: success_datas
                    }
                ]
            },
            handleData: function(reservation_datas) {
                let that = this
                let merchant_mapper = {}
                let null_merchant = []
                reservation_datas.forEach(function(data) {

                    if (data.buty_store.merchant !== null) {
                        if (merchant_mapper[data.buty_store.merchant.id] === undefined) {
                            merchant_mapper[data.buty_store.merchant.id] = {
                                "success": 0,
                                "fail": 0,
                                "total": 0,
                                "reservations": [],
                                "merchant_id": '',
                                "merchant_name": '',
                                "date_reservation": {}
                            }
                        }

                        merchant_mapper[data.buty_store.merchant.id].reservations.push(data)
                        merchant_mapper[data.buty_store.merchant.id]['merchant_id'] = data.buty_store.merchant.id
                        merchant_mapper[data.buty_store.merchant.id]['merchant_name'] = data.buty_store.merchant.name

                        if (data.commit_confirm_time !== null) {
                            let commit_confirm_time = that.getYYYYMMDD(new Date(data.commit_confirm_time), '-')
                            if (merchant_mapper[data.buty_store.merchant.id]['date_reservation'][commit_confirm_time] === undefined){
                                merchant_mapper[data.buty_store.merchant.id]['date_reservation'][commit_confirm_time] = {
                                    "success": 0,
                                    "fail": 0,
                                }
                            }
                        }

                        let date_created_time = that.getYYYYMMDD(new Date(data.date_created), '-')
                        if (merchant_mapper[data.buty_store.merchant.id]['date_reservation'][date_created_time] === undefined) {
                            merchant_mapper[data.buty_store.merchant.id]['date_reservation'][date_created_time] = {
                                "success": 0,
                                "fail": 0,
                            }
                        }

                        // 算各個供應商成功和失敗的數量
                        merchant_mapper[data.buty_store.merchant.id]['total'] += 1
                        if (data.commit_confirm_time !== null) {
                            merchant_mapper[data.buty_store.merchant.id]['success'] += 1
                            let commit_confirm_time = that.getYYYYMMDD(new Date(data.commit_confirm_time), '-')
                            merchant_mapper[data.buty_store.merchant.id]['date_reservation'][commit_confirm_time]['success'] += 1

                        }
                        else {
                            merchant_mapper[data.buty_store.merchant.id]['fail'] += 1
                            merchant_mapper[data.buty_store.merchant.id]['date_reservation'][date_created_time]['fail'] += 1
                        }

                    }
                    else {
                        null_merchant.push(data)
                    }

                })
                
                let keys = Object.keys(merchant_mapper)
                let merchant_datas = []
                let merchant_chart_data = {}
                keys.forEach(function(key){
                    merchant_datas.push(merchant_mapper[key])

                    let date_keys = Object.keys(merchant_mapper[key]['date_reservation']) 

                    date_keys.forEach(function(date_key){
                        if (merchant_chart_data[date_key] === undefined) {
                            merchant_chart_data[date_key] = {
                                "success": 0,
                                "fail": 0,
                            }
                        }

                        merchant_chart_data[date_key]['success'] += merchant_mapper[key]['date_reservation'][date_key]['success']
                        merchant_chart_data[date_key]['fail'] += merchant_mapper[key]['date_reservation'][date_key]['fail']
                    })

                })
                console.log('result', merchant_mapper)
                console.log('null_merchant', JSON.stringify(null_merchant))
                console.log('merchant_chart_data', merchant_chart_data)

                return {
                    reservation_data_mapper: merchant_mapper,
                    merchant_chart_data: merchant_chart_data,
                    merchant_datas: merchant_datas,
                }

            },
            handleMerchantData: function(reservation_datas) {
                let that = this
                let data = []
                let store_mapper = {}
                reservation_datas.forEach(function(data){

                    if (store_mapper[data.buty_store.store_id] === undefined) {
                        store_mapper[data.buty_store.store_id] = {
                               "success": 0,
                                "fail": 0,
                                "total": 0,
                                "reservations": [],
                                "store_id": '',
                                "store_name": '',
                                "date_reservation": {}
                        }
                    }

                    store_mapper[data.buty_store.store_id]['reservations'].push(data)
                    store_mapper[data.buty_store.store_id]['store_id'] = data.buty_store.store_id
                    store_mapper[data.buty_store.store_id]['store_name'] = data.buty_store.store_name

                    if (data.commit_confirm_time !== null) {
                        let commit_confirm_time = that.getYYYYMMDD(new Date(data.commit_confirm_time), '-')
                        if (store_mapper[data.buty_store.store_id]['date_reservation'][commit_confirm_time] === undefined){
                            store_mapper[data.buty_store.store_id]['date_reservation'][commit_confirm_time] = {
                                "success": 0,
                                "fail": 0,
                            }
                        }
                    }

                    let date_created_time = that.getYYYYMMDD(new Date(data.date_created), '-')
                    if (store_mapper[data.buty_store.store_id]['date_reservation'][date_created_time] === undefined) {
                        store_mapper[data.buty_store.store_id]['date_reservation'][date_created_time] = {
                            "success": 0,
                            "fail": 0,
                        }
                    }

                    store_mapper[data.buty_store.store_id]['total'] += 1
                    if (data.commit_confirm_time !== null) {
                        store_mapper[data.buty_store.store_id]['success'] += 1
                        let commit_confirm_time = that.getYYYYMMDD(new Date(data.commit_confirm_time), '-')
                        store_mapper[data.buty_store.store_id]['date_reservation'][commit_confirm_time]['success'] += 1
                        
                    }
                    else {
                        store_mapper[data.buty_store.store_id]['fail'] += 1
                        store_mapper[data.buty_store.store_id]['date_reservation'][date_created_time]['fail'] += 1
                    }

                })

                let result = that.createChartDataSet(store_mapper)


                return {
                    reservation_data_mapper: store_mapper,
                    chart_data: result.chart_data,
                    datas: result.datas,
                }
            },
            handleChartData: function(chart_data){
                // 建立日期的labels
                let day_labels = Object.keys(chart_data)

                let success_datas = day_labels.map(function(day) {
                    return chart_data[day]['success']
                })

                let fail_datas = day_labels.map(function(day) {
                    return chart_data[day]['fail']
                })

                return {
                    labels : day_labels,
                    datasets: [
                        {
                            label: '未完成預約',
                            backgroundColor: '#fe6483',
                            borderColor: '#fe6483',
                            data: fail_datas,
                        },
                        {
                            label: '已完成預約',
                            backgroundColor: '#4bc0c0',
                            borderColor: '#4bc0c0',
                            data: success_datas
                        }
                    ]

                }
            },
            handleStoreData: function(reservation_datas, store_id){
                let that = this
                let data = []
                let resp_data =[]
                let item_mapper = {}

                data = reservation_datas.filter(function(data){
                    return data.buty_store.store_id === store_id
                })

                data.forEach(function(tmp_data){

                    if (item_mapper[tmp_data.product.ns_id] === undefined) {
                        item_mapper[tmp_data.product.ns_id] = {
                               "success": 0,
                                "fail": 0,
                                "total": 0,
                                "reservations": [],
                                "item_id": '',
                                "item_name": '',
                                "date_reservation": {}
                        }
                    }

                    item_mapper[tmp_data.product.ns_id]['reservations'].push(tmp_data)
                    item_mapper[tmp_data.product.ns_id]['item_id'] = tmp_data.product.ns_id
                    item_mapper[tmp_data.product.ns_id]['item_name'] = tmp_data.product.product_cname

                    if (data.commit_confirm_time !== null) {
                        let commit_confirm_time = that.getYYYYMMDD(new Date(tmp_data.commit_confirm_time), '-')
                        if (item_mapper[tmp_data.product.ns_id]['date_reservation'][commit_confirm_time] === undefined){
                            item_mapper[tmp_data.product.ns_id]['date_reservation'][commit_confirm_time] = {
                                "success": 0,
                                "fail": 0,
                            }
                        }
                    }

                    let date_created_time = that.getYYYYMMDD(new Date(tmp_data.date_created), '-')
                    if (item_mapper[tmp_data.product.ns_id]['date_reservation'][date_created_time] === undefined) {
                        item_mapper[tmp_data.product.ns_id]['date_reservation'][date_created_time] = {
                            "success": 0,
                            "fail": 0,
                        }
                    }


                    item_mapper[tmp_data.product.ns_id]['total'] += 1
                    if (tmp_data.commit_confirm_time) {
                        item_mapper[tmp_data.product.ns_id]['success'] += 1
                        let commit_confirm_time = that.getYYYYMMDD(new Date(tmp_data.commit_confirm_time), '-')
                        item_mapper[tmp_data.product.ns_id]['date_reservation'][commit_confirm_time]['success'] += 1
                    }
                    else {
                        item_mapper[tmp_data.product.ns_id]['fail'] += 1
                        item_mapper[tmp_data.product.ns_id]['date_reservation'][date_created_time]['fail'] += 1
                    }
                })

                let result = that.createChartDataSet(item_mapper)


                return {
                    reservation_data_mapper: item_mapper,
                    chart_data: result.chart_data,
                    datas: result.datas,
                }
            },
            getYYYYMMDD: function (date, symbol){
                let date_format = ''

                date_format += date.getFullYear().toString() + symbol
                if (date.getMonth() + 1 < 10) {
                    date_format += '0'
                }
                date_format += (date.getMonth() + 1).toString() + symbol

                if (date.getDate() < 10) {
                    date_format += '0'
                }
                date_format += date.getDate().toString()
                return date_format
            },
            caculateMerchantSummary: function(merchant_datas, type) {
                let that = this
                let result = null   
                let count = 0
                let total = 0
                let total_time = 0
                switch (type) {
                    case 'success':
                        merchant_datas.forEach(function(data){
                           count += data.success
                        })
                        result = count
                        // console.log('success',result)
                        break;

                    case 'fail':

                        merchant_datas.forEach(function(data){
                           count += data.fail 
                        })
                        result = count
                        // console.log('fail',result)
                        break;

                    case 'total':
                        merchant_datas.forEach(function(data){
                           count += data.total 
                        })
                        result = count
                        // console.log('total',result)
                        break;

                    case 'response_time':

                        merchant_datas.forEach(function(data){
                            
                            data.reservations.forEach(function(reservation){
                                if (reservation.commit_confirm_time !== null && reservation.date_created !== null) {
                                    total += 1
                                    let start_at = new Date(reservation.date_created).getTime()
                                    let commit_at = new Date(reservation.commit_confirm_time).getTime()
                                    total_time += commit_at - start_at
                                }
                            })

                        })

                        // console.log('total_time', total_time)

                        result = this.timeFormat(total_time / total)

                        break;
                    
                    case 'get_service_time':

                        merchant_datas.forEach(function(data){
                            
                            data.reservations.forEach(function(reservation){
                                if (reservation.rv_commit_time !== null && reservation.date_created !== null) {
                                    // console.log('reservation',reservation)
                                    total += 1
                                    let start_at = new Date(reservation.date_created).getTime()
                                    let commit_at = new Date(reservation.rv_commit_time).getTime()
                                    // console.log(reservation.date_created)
                                    // console.log(new Date(reservation.date_created).getTime())
                                    // console.log(reservation.rv_commit_time)
                                    // console.log(new Date(reservation.rv_commit_time).getTime())
                                    // console.log(that.timeFormat(commit_at - start_at))
                                    total_time += commit_at - start_at
                                }
                            })

                        })

                        // console.log('total_time', that.timeFormat(total_time))
                        // console.log('total', total)

                        result = this.timeFormat(total_time / total)

                        break;

                }

                return result

            },
            timeFormat: function(average) {
                let result = ''
                if (isNaN(average)) {
                    result = '無預約成功數可以計算'
                }
                else if (average < 1000) {
                    result = (average / 1000).toFixed(2) + '秒'
                }
                else if(average <= 60000) {
                    result = (average / 1000).toFixed(2) + '分'
                }
                else {
                    result = (average / 3600000).toFixed(0)

                    if (result > 24) {
                        result = (result / 24).toFixed(0) + '天'
                    }
                    else {
                        result = result  + '時'
                    }
                }
                return result
            },
            createChartDataSet: function(data_mapper){
                let keys = Object.keys(data_mapper)
                let merchant_datas = []
                let merchant_chart_data = {}
                keys.forEach(function(key){
                    merchant_datas.push(data_mapper[key])

                    let date_keys = Object.keys(data_mapper[key]['date_reservation']) 

                    date_keys.forEach(function(date_key){
                        if (merchant_chart_data[date_key] === undefined) {
                            merchant_chart_data[date_key] = {
                                "success": 0,
                                "fail": 0,
                            }
                        }

                        merchant_chart_data[date_key]['success'] += data_mapper[key]['date_reservation'][date_key]['success']
                        merchant_chart_data[date_key]['fail'] += data_mapper[key]['date_reservation'][date_key]['fail']
                    })

                })

                return {
                    datas: merchant_datas,
                    chart_data: merchant_chart_data
                }
            }
            
        },
        mounted: async function() {
            // await this.getData(this.start_at, this.end_at)
        }
    }

</script>
<style scoped>
.filter_container {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
}
.chart-container > div {
    height: 100%;
}
</style>